





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { firestore, collections } from "@/configs/firebase";
import { User } from "@/types";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";
import featureConfigs from "@/helpers/featureConfigs";

@Component
export default class VerificationClaim extends Vue {
  @Prop({ required: true }) lead!: any;
  @State("user") user!: User;

  selectedAgentOfRecord: string = "";
  get agentOfRecord() {
    return featureConfigs.getAgentOfRecord();
  }

  get claimColor(): string {
    const claim = this.claimTitle;
    if (claim === "Claim") return "primary";
    return "pink";
  }

  get claimTitle(): string {
    if (this.lead.verification_agent_email == this.user.email) {
      return "Unclaim";
    }
    return "Claim";
  }

  get productNames() {
    if (!this.lead || !this.lead.products) {
      return [];
    }
    return Object.values(this.lead.products)
      .map((val: any) => val.name)
      .join(", ");
  }

  get assignedCloser() {
    if (this.lead) {
      const closer = objectify(this.lead.assigned_agent_email_by_role).closer;
      if (closer) {
        return closer;
      }
    }
    return "n/a";
  }

  setAgentOfRecord(val: string): void {
    this.selectedAgentOfRecord = val;
  }

  async handleClaim(): Promise<void> {
    try {
      if (this.lead.verification_agent_email == this.user.email) {
        await collections.lead
          .doc(this.lead.id)
          .update({ verification_agent_email: null, agent_of_record: null });
      } else {
        if (!this.selectedAgentOfRecord) {
          this.$toasted
            .error("Please select an agent of record to claim verification.")
            .goAway(2000);
          return logger("error", "agent of record not selected");
        }
        await collections.lead.doc(this.lead.id).update({
          verification_agent_email: this.user.email,
          agent_of_record: this.selectedAgentOfRecord
        });
      }
    } catch (err) {
      logger("error", "handle clain error", err);
      this.$toasted.error("Verification claim failed.").goAway(2000);
    }
  }
}
